import { error } from "@sveltejs/kit";
import client from "$lib/gql/apolloClient";
import { GetPageDoc } from "$lib/gql/genCms/codegen";
import type { GetPageQuery } from "$lib/gql/genCms/codegen";
import cfg from "$lib/config/config";
import { Errors } from "$lib/data/errors.data";

export const trailingSlash = "never";

/** @type {import('./$types').PageLoad} */
export async function load({ parent }) {
  const parentData = await parent();

  try {
    const pageQuery = await client.query<GetPageQuery>({
      query: GetPageDoc,
      variables: {
        pageId: cfg.PAGE_HOME,
        limit: 100,
      },
      context: {
        clientName: "cms",
        clientIP: parentData?.session.clientIP,
        preview: parentData?.preview,
      },
      errorPolicy: "ignore", // allows page not found errors to be handled below
    });

    if (!pageQuery.data?.Page) {
      throw error(404, Errors.NotFound);
    }

    return {
      pageData: pageQuery,
    };
  } catch (err: any) {
    throw error(404, {
      message: err && err.message ? err.message : Errors.NotFound,
    });
  }
}
